import config from 'netxcore@netx/core-category/config';

Object.assign(config, {
	MODAL: false,
	tree: true,
	displayCategoriesAsAssets: true,

	categoryid: 1,

	TREE_MAX_DEPTH: 90,
});

export default config;
